<template>
  <MDBNavbarItem v-if="availableLocales.length > 1">
    <span v-for="(locale, index) in availableLocales" :key="locale" class="cursor--pointer"
      @click="setLanguage(locale)">
      {{ formattedLocales[index] }}
      <span v-if="index < availableLocales.length - 1"> / </span>
    </span>
  </MDBNavbarItem>
</template>

<script setup>
import ApiService from "@/services/api.service"
import { MDBNavbarItem } from 'mdb-vue-ui-kit'
import { computed, inject } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n' // Import useI18n to interact with i18n
// Vuex Store
const store = useStore()

const { locale } = useI18n() // Get the reactive locale property from i18n

// Available locales for the tenant
const runtimeAvailableLocales = inject("availableLocales", []);
const availableLocales = computed(() => {
  return Array.isArray(runtimeAvailableLocales) ? runtimeAvailableLocales : []
})

// Computed property to format locales to display only language part in uppercase
const formattedLocales = computed(() => {
  return availableLocales.value.map((loc) => loc.split("-")[0].toUpperCase())
})

const setLanguage = (newLocale) => {
  locale.value = newLocale // Update the i18n locale
  ApiService.setLocale(newLocale)
  store.commit("SET_CURRENT_LOCALE", newLocale);
}
</script>
